@if (isCertificationStep !== undefined && isCertificationStep !== null) {
  <div class="taxes-wrapper" [ngClass]="{ 'taxes-specifics': !isPromptsBannerShown }">
    <div class="text-container">
      <div class="left-container">
        <div class="text-section">
          <span class="title">{{ title | translate }}</span>
          <span class="message"
            >{{ message | translate }}
            @if (!isCertificationStep) {
              <a (click)="onLearnMore()">{{
                "tax_learn_more" | translate
              }}</a>
              }</span
              >
            </div>
          </div>
          <div class="right-container">
            <div class="buttons-section">
              <button
                (click)="isCertificationStep ? onTaxableConfirm() : onDoItLater()"
                class="btn btn-inverse buttons left"
                [ngClass]="{ disabled: isUpdatingStatus }">
                {{ firstButton | translate }}</button
                >
                @if (!isUpdatingStatus) {
                  <button
                    (click)="isCertificationStep ? onTaxableDeclined() : onShareTaxDetails()"
                    class="btn btn-primary buttons">
                    {{ secondButton | translate }}</button
                    >
                  } @else {
                    <button class="btn btn-primary buttons disabled">
                      <loading-spinner class="no-padding"></loading-spinner>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
